document.addEventListener('DOMContentLoaded', () => {
  const iframeObserver = (element) => {
    const iframe = element.querySelector('iframe');
    const roundToTwo = price => (Math.round(price * 100) / 100).toFixed(2).replace('.', ',');
    let timeout;
    let initialPrice;

    iframe.addEventListener('load', () => {
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (!mutation.target.classList.contains('Offer-Icon-Wrapper')) return;

          const regPrice = /[\d,]+/g;
          const totalPrice = iframeDoc.querySelector(':not(.Upsell-List) .Offer-Price');
          const currency = totalPrice?.textContent.split(regPrice);

          if (!initialPrice) {
            initialPrice = parseFloat(
              totalPrice?.textContent.match(regPrice)?.[0]?.replace(',', '.') || 0
            );
          }
          if (!initialPrice || !totalPrice) return;
          if (timeout) clearTimeout(timeout);

          timeout = setTimeout(() => {
            const upsellItems = Array.from(iframeDoc.querySelectorAll('.Upsell-Item'));

            if (!totalPrice?.textContent || upsellItems.length === 0) return;
            let finalPrice = initialPrice;

            upsellItems.forEach((item) => {
              const itemRawPrice = item.querySelector('.Offer-Price')?.textContent;
              if (itemRawPrice) {
                const price = parseFloat(itemRawPrice.match(regPrice)?.[0]?.replace(',', '.') || 0);
                if (!!item.querySelector('.animated-checkmark--finished')) finalPrice += price;
              }
            });
            totalPrice.textContent = `${currency[0]}${roundToTwo(finalPrice)} ${currency[1]}`;
          }, 1100);
        });

      });
      observer.observe(iframeDoc.body, {
        childList: true,
        subtree: true
      });
    });
  }
  const observer = new MutationObserver(() => {
    const cart = document.getElementById('candycart-root');
    if (cart?.innerHTML) {
      iframeObserver(cart);
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
